export const servicesData = {
  badge: "SERVICES",
  headline: "Marketing That Keeps Your Calendar Full",
  description:
    "Designed for Aesthetic Clinics that expect more, our marketing systems bring predictability to your growth. With tailored campaigns and automated patient follow-ups, you'll spend less time chasing leads and more time serving new clients.",
  callout: "Want to stop guessing with your marketing?",
  ctaButton: {
    text: "Let's talk strategy",
    link: "/contact",
  },
  services: [
    {
      iconName: "Users",
      title: "Lead Generation",
      description: "We attract high-quality patients ready to purchase.",
      link: "/services#lead-generation",
    },
    {
      iconName: "Calendar",
      title: "Social Media & Calendar Management",
      description:
        "From engaging your community to filling your schedule, we handle your entire online presence and appointment flow.",
      link: "/services#social-media",
    },
    {
      iconName: "Workflow",
      title: "Automations",
      description:
        "From the first click to booked consultation, everything runs in sync.",
      link: "/services#automations",
    },
    {
      iconName: "Globe",
      title: "Website Design & Optimization",
      description:
        "Your clinic's digital storefront should be as stunning as your results. We design bespoke, mobile-optimized sites that build instant patient trust.",
      link: "/services#website",
    },
  ],
};
